import { NgModule } from '@angular/core';

import { TRANSLATION_PROVIDERS } from '../services/translation/lang/translations';
import { TranslationService } from '../services/translation/translation.service';
import { LoaderIndicatorService } from '../services/loader-indicator/loader-indicator.service';
import { SecurityModule } from '../services/security/security.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToasterModule } from 'angular2-toaster';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';

/**
 * Core module
 * contains services, single-instance components, and export any third-party modules needed in AppModule
 */
@NgModule({
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        HttpClientModule,
        ToasterModule.forRoot()
    ],
    providers: [
        TranslationService,
        TRANSLATION_PROVIDERS,
        LoaderIndicatorService,
        SecurityModule
    ],
    exports: [
        SecurityModule,
        ToasterModule
    ]
})
export class CoreModule {
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts